import { executeApiCall } from 'services/api';
import { getLoaders } from 'entities/hooks/load';

import { Notification } from './types';

interface ListNotificationParams {
  lastDateReceived?: string;
  target?: 'past' | 'future';
}

export const notificationLoaders = getLoaders({
  fetchNotifications: {
    load: async (params: ListNotificationParams | undefined): Promise<Notification[]> => {
      const { lastDateReceived, target } = params ?? {};

      return executeApiCall({
        path: '/users/notifications',
        method: 'get',
        payload: {
          reference: target,
          lastDateReceived,
        },
      });
    },
  },
});
